import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function supplier({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <rect
        fill="none"
        width="8"
        height="8"
        x="5"
        y="4"
        strokeWidth="2"
        rx="1.8"
      ></rect>
      <path
        fill="none"
        strokeWidth="2"
        d="M4 13.8A1.8 1.8 0 015.8 12h4.4a1.8 1.8 0 011.8 1.8V20H5.8A1.8 1.8 0 014 18.2v-4.4zM12 13.8a1.8 1.8 0 011.8-1.8h4.4a1.8 1.8 0 011.8 1.8v4.4a1.8 1.8 0 01-1.8 1.8H12v-6.2z"
      />
      <path strokeLinecap="round" strokeWidth="2" d="M16 12v3M8 12v3M9 4v3" />
    </svg>
  );
}

export default supplier;
